const NAV = {
    0: [
        {
            title: 'Пользователи',
            link: '/admin/users',
        },
        {
            title: 'Заявки на восстановление',
            link: '/admin/password-recovery',
        },
        {
            title: 'Попытки входа',
            link: '/admin/login-attempts',
        },
        {
            title: 'Профиль Экспертов',
            link: '/admin/experts',
        },
        {
            title: 'Объявления пилотов',
            link: '/admin/pilot-announcements',
        },
        {
            title: 'Виды услуг пилотов',
            link: '/admin/pilot-services',
        },
        {
            title: 'Подготовительные курсы',
            link: '/admin/course-preparation',
        },
        {
            title: 'Тренинги',
            link: '/admin/trainings',
        },
        {
            title: 'Группы курса',
            link: '/admin/course-group',
        },
        {
            title: 'Заявки',
            link: '/admin/course/status',
        },
        {
            title: 'Оценки',
            link: '/admin/course/estimates',
        },
        {
            title: 'Законы',
            link: '/admin/content/law',
            childrens: [
                {
                    title: 'Список',
                    link: '/admin/content/law',
                },
                {
                    title: 'Категории',
                    link: '/admin/category/law',
                },
            ]
        },
        {
            title: 'Новости',
            link: '/admin/content/news',
            childrens: [
                {
                    title: 'Список',
                    link: '/admin/content/news',
                },
                {
                    title: 'Категории',
                    link: '/admin/category/news',
                },
            ]
        },
        {
            title: 'Наука',
            link: '/admin/content/science',
            childrens: [
                {
                    title: 'Список',
                    link: '/admin/content/science',
                },
                {
                    title: 'Категории',
                    link: '/admin/category/science',
                },
            ]
        },
        {
            title: 'Соревнованиях/Конкурсы/Турниры',
            link: '/admin/content/contest',
            childrens: [
                {
                    title: 'Список',
                    link: '/admin/content/contest',
                },
                {
                    title: 'Категории',
                    link: '/admin/category/contest',
                },
            ]
        },
        {
            title: 'Каталог продукции БПЛА',
            link: '/admin/content/uav_catalog',
            childrens: [
                {
                    title: 'Список',
                    link: '/admin/content/uav_catalog',
                },
                {
                    title: 'Категории',
                    link: '/admin/category/uav_catalog',
                },
            ]
        },
        {
            title: 'Платежи FreedomPay',
            link: '/admin/payment-orders',
        },
        {
            title: 'Обратная связь',
            link: '/admin/user-feedback',
        },
    ],
    3: [
        {
            title: 'Пользователи',
            link: '/admin/users',
        },
        {
            title: 'Заявки на восстановление',
            link: '/admin/password-recovery',
        },
        {
            title: 'Попытки входа',
            link: '/admin/login-attempts',
        },
        {
            title: 'Профиль Экспертов',
            link: '/admin/experts',
        },
        {
            title: 'Объявления пилотов',
            link: '/admin/pilot-announcements',
        },
        {
            title: 'Виды услуг пилотов',
            link: '/admin/pilot-services',
        },
        {
            title: 'Подготовительные курсы',
            link: '/admin/course-preparation',
        },
        {
            title: 'Тренинги',
            link: '/admin/trainings',
        },
        {
            title: 'Группы курса',
            link: '/admin/course-group',
        },
        {
            title: 'Заявки',
            link: '/admin/course/status',
        },
        {
            title: 'Оценки',
            link: '/admin/course/estimates',
        },
        {
            title: 'Законы',
            link: '/admin/content/law',
            childrens: [
                {
                    title: 'Список',
                    link: '/admin/content/law',
                },
                {
                    title: 'Категории',
                    link: '/admin/category/law',
                },
            ]
        },
        {
            title: 'Новости',
            link: '/admin/content/news',
            childrens: [
                {
                    title: 'Список',
                    link: '/admin/content/news',
                },
                {
                    title: 'Категории',
                    link: '/admin/category/news',
                },
            ]
        },
        {
            title: 'Наука',
            link: '/admin/content/science',
            childrens: [
                {
                    title: 'Список',
                    link: '/admin/content/science',
                },
                {
                    title: 'Категории',
                    link: '/admin/category/science',
                },
            ]
        },
        {
            title: 'Соревнованиях/Конкурсы/Турниры',
            link: '/admin/content/contest',
            childrens: [
                {
                    title: 'Список',
                    link: '/admin/content/contest',
                },
                {
                    title: 'Категории',
                    link: '/admin/category/contest',
                },
            ]
        },
        {
            title: 'Каталог продукции БПЛА',
            link: '/admin/content/uav_catalog',
            childrens: [
                {
                    title: 'Список',
                    link: '/admin/content/uav_catalog',
                },
                {
                    title: 'Категории',
                    link: '/admin/category/uav_catalog',
                },
            ]
        },
        {
            title: 'Платежи FreedomPay',
            link: '/admin/payment-orders',
        },
        {
            title: 'Обратная связь',
            link: '/admin/user-feedback',
        },
    ],
    8: [
        {
            title: 'Подготовительные курсы',
            link: '/admin/course-preparation',
        },
        {
            title: 'Тренинги',
            link: '/admin/trainings',
        },
        {
            title: 'Группы курса',
            link: '/admin/course-group',
        },
        {
            title: 'Заявки',
            link: '/admin/course/status',
        },
        {
            title: 'Оценки',
            link: '/admin/course/estimates',
        },
        {
            title: 'Новости',
            link: '/admin/news',
        },
    ],
    6: [

    ],
    10: [
        {
            title: 'Новости',
            link: '/admin/news',
        },
    ]
}
export default NAV 